import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import userReducer from "./user"

const persistConfig = {
    key: 'root',
    storage,
}

const persistedReducer = persistReducer(persistConfig, userReducer)

const store = configureStore({
    reducer: {user: persistedReducer},
    middleware: getDefaultMiddleware => getDefaultMiddleware({serializableCheck: false}),
})

const persistor = persistStore(store)

export default { store, persistor };